import { render } from "./ConfirmCheckupCopyModal.vue?vue&type=template&id=58ca07e3"
import script from "./ConfirmCheckupCopyModal.vue?vue&type=script&lang=js"
export * from "./ConfirmCheckupCopyModal.vue?vue&type=script&lang=js"

import exportComponent from "/home/nodeapps/uzb/frontendBuild/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__